/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { EditorState, convertToRaw } from 'draft-js';
import { Button, Flex } from '@adobe/react-spectrum';
import { Editor } from 'react-draft-wysiwyg';
import Select from 'react-select';
import { AddCommentContainer, EditorWrap, Label } from './CommentStyle';
import actionWebInvoke from '../../utils/actionCallUtils';
import actions from '../../config.json';
import OBJCODE from '../../constants';

const AddComment = ({
  projectID,
  taskID,
  userEmail,
  isAddComment,
  setAddComment,
}) => {
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty(),
  );
  const [userTeamState, setUserTeamState] = useState([]);
  const [convertedContent, setConvertedContent] = useState(null);
  const [sessionID, setSessionID] = useState('');
  const [tagsQuery, setTagsQuery] = useState();
  const [notifyUserRef, setNotifyUserRef] = useState(null);
  const tagsList = [];

  const convertContentToHTML = () => {
    const currentContentAsHTML = JSON.stringify(
      convertToRaw(editorState.getCurrentContent()),
    );
    setConvertedContent(currentContentAsHTML);
  };
  const handleEditorChange = state => {
    setEditorState(state);
    convertContentToHTML();
  };
  async function login() {
    const fields = ['sessionID'];
    const queryParams = { username: userEmail };
    const actionResponse = await actionWebInvoke(
      actions['workfront-action'],
      {},
      { objCode: OBJCODE.LOGIN, queryParams, fields },
    );
    setSessionID(actionResponse.sessionID);
  }
  function getQueryParams(userTagList) {
    let queryParams;
    let objectID;
    let objectCode;
    if (projectID) {
      objectID = projectID;
      objectCode = 'PROJ';
    } else {
      objectID = taskID;
      objectCode = 'TASK';
    }
    if (userTagList) {
      queryParams = {
        updates: JSON.stringify({
          noteText: editorState.getCurrentContent().getPlainText('\u0001'),
          html: '0',
          json: `${convertedContent}`,
          noteObjCode: objectCode,
          objID: objectID,
          tags: tagsQuery,
        }),
        method: 'POST',
        sessionID,
      };
    } else {
      queryParams = {
        updates: JSON.stringify({
          noteText: editorState.getCurrentContent().getPlainText('\u0001'),
          html: '0',
          json: `${convertedContent}`,
          noteObjCode: objectCode,
          objID: objectID,
        }),
        method: 'POST',
        sessionID,
      };
    }
    return queryParams;
  }

  async function addNotes(userTagList, text) {
    const fields = [
      'ID',
      'owner:name',
      'project:name',
      'noteText',
      'entryDate',
    ];
    const queryParams = getQueryParams(userTagList, text);
    await actionWebInvoke(
      actions['workfront-action'],
      {},
      { objCode: OBJCODE.NOTE, queryParams, fields },
    );
    setAddComment(!isAddComment);
    setEditorState(null);
    notifyUserRef.select.clearValue();
  }

  async function getUsersAndTeams() {
    const fields = ['ID', 'name', 'objCode'];
    const userArray = await actionWebInvoke(
      actions['workfront-action'],
      {},
      { objCode: OBJCODE.USER, fields },
    );
    const teamArray = await actionWebInvoke(
      actions['workfront-action'],
      {},
      { objCode: OBJCODE.TEAM, fields },
    );
    const options = [...userArray, ...teamArray];
    setUserTeamState(options);
  }

  const notifyOptions = userTeamState.map(element => {
    return { label: element.name, value: element.ID };
  });

  const handleNotifyUser = ID => {
    if (ID !== null) {
      ID.map(selectElement => {
        const selectedUser = userTeamState.find(
          userCode => userCode.ID === selectElement.value,
        );
        tagsList.push({
          objID: selectElement.value,
          objObjCode: selectedUser.objCode,
        });
        setTagsQuery(tagsList);
        return null;
      });
    }
  };

  useEffect(() => {
    getUsersAndTeams();
    login();
  }, []);

  return (
    <AddCommentContainer>
      <EditorWrap>
        <Editor
          toolbar={{
            options: ['inline', 'list', 'link'],
            inline: {
              options: ['bold', 'italic', 'underline'],
            },
            list: {
              options: ['unordered', 'ordered'],
            },
            link: {
              options: ['link'],
            },
          }}
          placeholder="Add a new comment"
          wrapperClassName="wrapper-class"
          editorClassName="editor-class"
          toolbarClassName="toolbar-class"
          editorState={editorState}
          onEditorStateChange={handleEditorChange}
        />
      </EditorWrap>
      <Label>Notify</Label>
      <Flex direction="row" marginBottom="25px">
        <div style={{ width: '230px' }}>
          <Select
            isMulti
            styles={{ indicatorSeparator: () => ({ display: 'none' }) }}
            isSearchable
            isClearable
            name="notify"
            placeholder="Add people or teams..."
            options={notifyOptions || []}
            className="basic-multi-select"
            classNamePrefix="react-select"
            onChange={ID => handleNotifyUser(ID)}
            ref={ref => {
              setNotifyUserRef(ref);
            }}
          />
        </div>
        <Button
          variant="cta"
          marginStart="20px"
          width="85px"
          onPress={() => {
            addNotes(tagsList);
          }}
        >
          Submit
        </Button>
      </Flex>
    </AddCommentContainer>
  );
};

export default AddComment;
